import React, { useEffect } from "react";
import { motion, useMotionValue, useTransform, animate } from "framer-motion";

export default function InfiniteRandomSpringClipFill() {
  const progress = useMotionValue(0);

  const clipPath = useTransform(
    progress,
    [0, 100],
    ["inset(0 100% 0 0)", "inset(0 0% 0 0)"]
  );

  useEffect(() => {
    let target = 0;
    let controls;

    function animateToNext() {
      if (target >= 100) {
        // Reset to 0 instantly when finished, then restart animation
        progress.set(0);
        target = 0;
        setTimeout(animateToNext, 500); // small delay before restarting
        return;
      }

      const increment = Math.floor(Math.random() * 11) + 20;
      target = Math.min(100, target + increment);

      controls = animate(progress, target, {
        type: "spring",
        stiffness: 120,
        damping: 20,
        onComplete: () => {
          setTimeout(animateToNext, 300 + Math.random() * 400);
        },
      });
    }

    animateToNext();

    return () => controls?.stop();
  }, [progress]);

  return (
    <div
      style={{
        position: "relative",
        fontSize: "3rem",
        fontWeight: "700",
        display: "inline-block",
        cursor: "wait",
        userSelect: "none",
        fontFamily: "sans-serif",
        color: "#f0f0f0",
      }}>
      <div aria-hidden="true" style={{ color: "#f0f0f0" }}>
        Loading
      </div>
      <motion.div
        aria-hidden="true"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
          background:
            "linear-gradient(90deg, transparent 0%, #bb00ff 50%, transparent 100%)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          WebkitTextFillColor: "transparent",
          pointerEvents: "none",
          clipPath,
          willChange: "clip-path",
        }}>
        Loading
      </motion.div>
    </div>
  );
}
